// extracted by mini-css-extract-plugin
export default {"header":"map_header__axAie","tooltip":"map_tooltip__b5Tn5","tooltipMobile":"map_tooltipMobile__2Ld7p","tooltipLink":"map_tooltipLink__6kVlt"};